/**
 * ? @description : SPOC : Trainer Profiles Component
 */

// Dependencies
import React, { Fragment, useState, useEffect, useRef } from "react";
import MUIDataTable, { TableFilterList } from "mui-datatables";
import { Box, Chip, CircularProgress, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
// Modals
import TrainerData from "./modals/TrainerData";

// Axios Component
import Axios from "../../../../../axios/Axios";
import axios from "axios";
import dayjs from "dayjs";
import { LibraryBooks } from "@mui/icons-material";

// chat box module
// import styles from "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css";
import {
  MainContainer,
  ChatContainer,
  MessageList,
  Message,
  MessageInput,
  ConversationHeader,
  Conversation,
} from "@chatscope/chat-ui-kit-react";
import { Modal } from "react-bootstrap";
import io from "socket.io-client";

import "../../../../../css/Common.css";

function TrainerProfiles() {
  // const dispatch = useDispatch();
  const spoc_id = sessionStorage.getItem("user_id");
  // * State Variables
  const [teachersData, setTeachersData] = useState([]);
  const [selectedRowData, setSelectedRowData] = useState([]);
  const [teacherModal, setTeacherModal] = useState(false);
  const [isDataFetchError, setIsDataFetchError] = useState(false);
  const [openChatBox, setOpenChatBox] = useState(false);
  const [chatBoxTeacherData, setChatBoxTeacherData] = useState({
    teacherId: "",
    teacherName: "",
    teacherStatus: "",
  });
  const inputRef = useRef(null);

  // for pagination state
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const handleRowsPerPageChange = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
  };
  // * Fetching Data
  useEffect(() => {
    const controller = axios.CancelToken.source();
    if (!openChatBox) {
      (async () => {
        try {
          const options = {
            method: "get",
            url: `teacher/get/spoc/teacherdetails/${spoc_id}`,
            auth: true,
            data: null,
            token: { cancelToken: controller.token },
          };

          const response = await Axios(
            options.method,
            options.url,
            options.auth,
            options.data,
            options.token
          );
          // console.log(response.data);

          let teacherTrainingList = response.data.flatMap((num) => num);
          teacherTrainingList.length !== 0
            ? setTeachersData(teacherTrainingList)
            : setIsDataFetchError(true);
        } catch (error) {
          if (!axios.isCancel(error)) {
            setIsDataFetchError(true);
            console.log(error);
          }
        }
      })();
      return () => {
        controller.cancel();
      };
    }
  }, [spoc_id, rowsPerPage, openChatBox]);

  // for chat messages card

  function ChartBox({
    open,
    onClose,
    spoc_id,
    teacherId,
    teacherName,
    teacherStatus,
  }) {
    // console.log(spoc_id, teacherId, 'spoc_id, teacherId,');

    const [socket, setSocket] = useState(null);
    const [message, setMessage] = useState("");
    const [messages, setMessages] = useState([]);

    // * Function Call previous chat message
    // useEffect(() => {
    //   if (!open || !teacherId || !spoc_id) return;

    //   const controller = axios.CancelToken.source();
    //   (async () => {
    //     if (teacherId) {
    //       try {
    //         let finalData = {
    //           spoc_id: spoc_id,
    //           teacher_id: teacherId
    //         }
    //         const options = {
    //           method: "post",
    //           url: `/messages/chat`,
    //           auth: true,
    //           data: finalData,
    //           token: { cancelToken: controller.token }
    //         };

    //         const readOptions = {
    //           method: "put",
    //           url: `/messages/update/chat/spoc/read/status`,
    //           auth: true,
    //           data: finalData,
    //           token: { cancelToken: controller.token }
    //         }

    //         let response = await Axios(
    //           options.method,
    //           options.url,
    //           options.auth,
    //           options.data,
    //           options.token,
    //         );

    //         let responseReadOptions = await Axios(
    //           readOptions.method,
    //           readOptions.url,
    //           readOptions.auth,
    //           readOptions.data,
    //           readOptions.token,
    //         );

    //         if (response.status === 200 && responseReadOptions.status === 200) {
    //           setMessages(response.data)
    //         }

    //       } catch (error) {
    //         if (!axios.isCancel(error)) {
    //           console.log(error);
    //         }
    //       }
    //     }
    //   })()
    //   return () => {
    //     controller.cancel();
    //   }
    // }, [open, spoc_id, teacherId]);
    useEffect(() => {
      const controller = axios.CancelToken.source();
      if (spoc_id && teacherId) {
        (async () => {
          try {
            let finalData = {
              spoc_id: spoc_id,
              teacher_id: teacherId,
            };

            const options = {
              method: "post",
              url: `/messages/chat`,
              auth: true,
              data: finalData,
              token: { cancelToken: controller.token },
            };

            const readOptions = {
              method: "put",
              url: `/messages/update/chat/spoc/read/status`,
              auth: true,
              data: finalData,
              token: { cancelToken: controller.token },
            };

            let [response, responseReadOptions] = await Promise.all([
              Axios(
                options.method,
                options.url,
                options.auth,
                options.data,
                options.token
              ),
              Axios(
                readOptions.method,
                readOptions.url,
                readOptions.auth,
                readOptions.data,
                readOptions.token
              ),
            ]);

            if (response.status === 200 && responseReadOptions.status === 200) {
              setMessages(response.data);
            }
          } catch (error) {
            if (!axios.isCancel(error)) {
              console.error(error);
            }
          }
        })();
      }

      return () => {
        controller.cancel();
      };
    }, [spoc_id, teacherId]);

    useEffect(() => {
      if (spoc_id && teacherId) {
        const newSocket = io("https://staginglteapi.letsteachenglishact.org", {
          reconnectionDelayMax: 10000,
        }); // Connect to the backend
        setSocket(newSocket);
        // console.log(spoc_id, teacherId, 'spoc_id, teacherId- line 107,');
        // Join the room based on spocId and teacherId
        newSocket.emit("joinRoom", { spoc_id: spoc_id, teacher_id: teacherId });

        // Listen for messages from the server
        newSocket.on("message", (data) => {
          setMessages((prevMessages) => [...prevMessages, data]); // Append new message to the chat
          // console.log(data);
        });

        // Cleanup when the component is unmounted
        return () => {
          newSocket.disconnect();
        };
      }
    }, [teacherId, open, spoc_id]);

    const sendMessage = () => {
      const spoc = "spoc";
      if (message && socket) {
        console.log("message", { spoc_id, teacherId, message, spoc });
        // Emit the message to the server
        socket.emit("message", {
          spoc_id: spoc_id,
          teacher_id: teacherId,
          message,
          sender: "spoc",
        });

        setMessage(""); // Clear input after sending
      }
      inputRef.current?.focus();
    };

    return (
      <Modal
        show={open}
        size="l"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        style={{ zIndex: 2000, position: "fixed" }}
        onHide={onClose}
      >
        <div style={{ position: "relative", height: "400px" }}>
          <MainContainer>
            <ChatContainer>
              <ConversationHeader>
                {/* <Avatar
      name="Akane"
      src={}
    /> */}
                {/* <Status  size="lg" status="available" /> */}

                <ConversationHeader.Content
                  info={teacherStatus === "active" ? "Active" : "Drop"}
                  userName={teacherName}
                />

                <ConversationHeader.Actions>
                  <CloseIcon onClick={onClose} />
                </ConversationHeader.Actions>
              </ConversationHeader>
              <MessageList
              // typingIndicator={<TypingIndicator content="" />}
              >
                {messages.map((msg, index) => {
                  console.log(msg);
                  const time = msg.sentTime || msg.created_at;
                  const formateTime = dayjs(time).format(
                    "DD-MMM-YYYY HH:mm:ss"
                  );
                  return (
                    <>
                      {msg.sender === "spoc" ? (
                        <>
                          <Message
                            key={index}
                            model={{
                              direction: "outgoing",
                              message: msg.message, // Assuming 'msg' contains 'text' property
                              sentTime: time, // Use sent time if available
                              sender: msg.sender || "Server", // Placeholder for sender
                            }}
                          />
                          {/* {showTime  === index && (
     <MessageSeparator style={{marginTop:'0px', paddingBottom :'10px'}} content={formateTime} />
                          )} */}
                          <div
                            style={{ fontSize: "xx-small", textAlign: "end" }}
                          >
                            {formateTime}
                          </div>
                        </>
                      ) : (
                        <>
                          <Message
                            key={index}
                            model={{
                              direction: "incoming",
                              message: msg.message, // Assuming 'msg' contains 'text' property
                              sentTime: time, // Use sent time if available
                              sender: msg.sender || "Server", // Placeholder for sender
                            }}
                          />
                          {/* {showTime && (
       <MessageSeparator style={{marginTop:'0px', paddingBottom :'15px'}} content={formateTime} />
                            )} */}
                          <div
                            style={{ fontSize: "xx-small", textAlign: "start" }}
                          >
                            {formateTime}
                          </div>
                        </>
                      )}
                    </>
                  );
                })}
              </MessageList>
              <MessageInput
                ref={inputRef}
                attachButton={false}
                placeholder="Type message here"
                value={message}
                onChange={setMessage}
                onSend={sendMessage}
              />
            </ChatContainer>
          </MainContainer>
        </div>
      </Modal>
    );
  }

  // * Column Declarations
  const columns = [
    {
      name: "teacher_id",
      label: "Teacher Id",
      options: {
        display: false,
        filter: true,
        filterType: "Dropdown",
        sort: true,
        sortDirection: "desc",
        download: true,
      },
    },
    {
      name: "teacher_name",
      label: "Teacher Name",
      options: {
        filter: true,
        filterType: "Dropdown",
        sort: true,
        download: true,
        // customBodyRender: (value) => {
        //   return (
        //     <div>
        //       <Chip
        //         label={value}
        //         color="primary"
        //         size="small"
        //         clickable
        //         onClick={() => setTeacherModal(true)}
        //       />
        //     </div>
        //   );
        // },
      },
    },
    // {
    //   name: "group_id",
    //   label: "Batch Id",
    //   options: {
    //     filter: true,
    //     filterType: "Dropdown",
    //     sort: true,
    //     download: true,
    //   },
    // },
    // {
    //   name: "group_name",
    //   label: "Batch Name",
    //   options: {
    //     filter: true,
    //     filterType: "Dropdown",
    //     sort: true,
    //     download: true,
    //   },
    // },
    {
      name: "audio_status",
      label: "Audio Status",
      options: {
        filter: true,
        filterType: "Dropdown",
        sort: true,
        download: true,
      },
    },
    // {
    //   name: "training_video_status",
    //   label: "Training Video Status",
    //   options: {
    //     filter: true,
    //     filterType: "Dropdown",
    //     sort: true,
    //     download: true,
    //   },
    // },
    {
      name: "attendance_status",
      label: "Attendance Status",
      options: {
        filter: true,
        filterType: "Dropdown",
        sort: true,
        download: true,
      },
    },
    // {
    //   name: "video_viewed_time",
    //   label: "Video Viewed Time",
    //   options: {
    //     filter: true,
    //     filterType: "Dropdown",
    //     sort: true,
    //     download: true,
    //   },
    // },
    {
      name: "role",
      label: "Role",
      options: {
        filter: true,
        filterType: "Dropdown",
        sort: true,
        download: true,
      },
    },
    // {
    //   name: "date_of_promotions",
    //   label: "Date of Promotions",
    //   options: {
    //     filter: true,
    //     filterType: "Dropdown",
    //     sort: true,
    //     download: true,
    //   },
    // },

    //   {
    //     name: 'spoc_unread_chat_count',
    //     label: "Chat Box",
    //     options: {
    //       filter: false,
    //       sort: false,
    //       customBodyRender: (_, data) => {
    //         // let studentId = data.rowData[3]
    //         let teacherId = data.rowData[0]
    //         // console.log(data.rowData);
    //         let teacherName = data.rowData[1]
    //         // console.log(data);
    //         let teacherStatus = data.rowData[8]
    //         let unreadCount = data.rowData[5]
    //         return (
    //           <IconButton
    //             onClick={() => {
    //               setOpenChatBox(true)
    //               setChatBoxTeacherData({
    //                 teacherId: teacherId,
    //                 teacherName: teacherName,
    //                 teacherStatus: teacherStatus,
    //               })
    //             }}
    //           >
    //             <Conversation
    //               // info="Yes, i can do it for you"
    //               // lastSenderName="Lilly"
    //               // name="Lilly"

    //               unreadCnt={unreadCount}
    //             >
    //               {/* <Avatar
    //   name="Lilly"
    //   src="https://chatscope.io/storybook/react/assets/lilly-aj6lnGPk.svg"
    // /> */}
    //               <Conversation.Operations visible>
    //                 <LibraryBooks color="primary"></LibraryBooks>
    //               </Conversation.Operations>
    //             </Conversation>
    //             {/* <Badge color="error"
    //              badgeContent={badgeCount}
    //              max={10}>
    //              <LibraryBooks color="primary"></LibraryBooks>

    //               </Badge> */}
    //           </IconButton>
    //         );
    //       },
    //     },
    //   },
    {
      name: "tcreated_at",
      label: "Registered Date",
      options: {
        filter: true,
        filterType: "Dropdown",
        sort: true,
        download: true,
        customBodyRender: (value) => {
          const formattedDate = value ? dayjs(value).format("DD-MM-YYYY") : "-";
          return <div>{formattedDate}</div>;
        },
      },
    },
    {
      name: "batch_member_id",
      label: "Batch Member Id",
      options: {
        filter: true,
        filterType: "Dropdown",
        sort: true,
        download: true,
        display: false,
      },
    },
    {
      name: "teacher_status",
      label: "Date of Promotions",
      options: {
        filter: true,
        filterType: "Dropdown",
        sort: true,
        display: false,
      },
    },
  ];

  // * Options for the Table Configuration
  const options = {
    textLabels: {
      body: {
        noMatch: isDataFetchError ? (
          "Sorry, No Data available"
        ) : (
          <CircularProgress />
        ),
      },
    },
    filter: true,
    filterType: "dropdown",
    responsive: "stacked",
    elevation: 0,
    rowsPerPage: rowsPerPage,
    rowsPerPageOptions: [5, 10, 20],
    onChangeRowsPerPage: handleRowsPerPageChange,
    jumpToPage: true,
    fixedHeader: true,
    fixedSelectColumn: true,
    tableBodyHeight: "auto",
    onRowClick: (rowData) => {
      setSelectedRowData(rowData);
    },
    customSearch: (searchQuery, currentRow, columns) => {
      currentRow.forEach((col) => {
        if (col && col.toString().indexOf(searchQuery) >= 0) {
          return setIsDataFetchError(true);
        }
      });
    },
  };

  const CustomChip = ({ label, onDelete }) => {
    return (
      <Chip
        variant="outlined"
        color="secondary"
        label={label}
        onDelete={onDelete}
      />
    );
  };

  const CustomFilterList = (props) => {
    return <TableFilterList {...props} ItemComponent={CustomChip} />;
  };

  return (
    <Fragment>
      {/* Table */}
      <Box>
        <MUIDataTable
          title={`Teachers Training Data (${teachersData.length})`}
          data={teachersData}
          columns={columns}
          options={options}
          components={{ TableFilterList: CustomFilterList }}
        />
      </Box>

      {/* Modal */}
      <TrainerData
        open={teacherModal}
        onClose={() => setTeacherModal(false)}
        selecteddata={selectedRowData}
      />
      <ChartBox
        open={openChatBox}
        onClose={() => {
          setOpenChatBox(false);
          setChatBoxTeacherData({
            teacherId: "",
            teacherName: "",
            teacherStatus: "",
          });
        }}
        spoc_id={spoc_id}
        teacherId={chatBoxTeacherData.teacherId}
        teacherName={chatBoxTeacherData.teacherName}
        teacherStatus={chatBoxTeacherData.teacherStatus}
      />
    </Fragment>
  );
}

export default TrainerProfiles;
